import { toValue } from "#imports";
export const useModifiedValue = ({
  props,
  value
}) => {
  const val = toValue(value);
  if (val === "on" || val === null) {
    return null;
  }
  if (props?.modelModifiers?.number && typeof val !== "boolean" && typeof val !== "number") {
    return Number.parseFloat(val);
  }
  if (props?.modelModifiers?.boolean && typeof val !== "boolean") {
    return val === "true" || val === "1";
  }
  return val;
};
